import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { imgUrl } from "@/lib/api";
import { SectionHeading } from "./kit";

const SPANS = ["col-span-2 row-span-2", "", "", "", "", "col-span-2"];

export const Gallery = ({ content }) => {
  const [active, setActive] = useState(null);
  const gallery = content.images?.gallery || [];
  const flyers = content.images?.flyer || [];
  return (
    <section id="gallery" className="bg-neutral-950 px-5 py-20 md:py-28" data-testid="gallery-section">
      <div className="mx-auto max-w-6xl">
        <SectionHeading eyebrow="Moments" title="The" accent="gallery" />
        {gallery.length === 0 && <p className="text-neutral-500" data-testid="gallery-empty">Photos coming soon.</p>}
        <div className="grid auto-rows-[140px] grid-cols-2 gap-3 sm:auto-rows-[200px] md:grid-cols-4">
          {gallery.map((g, i) => (
            <button
              key={g.id}
              data-testid={`gallery-image-${i}`}
              onClick={() => setActive(g)}
              className={`group relative overflow-hidden rounded-md border border-neutral-800 ${SPANS[i % SPANS.length]}`}
            >
              <img src={imgUrl(g.url)} alt={g.caption || "Festival photo"} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              {g.caption && (
                <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 to-transparent p-3 text-left font-display text-sm text-neutral-100">
                  {g.caption}
                </span>
              )}
            </button>
          ))}
        </div>

        <div id="flyers" className="mt-20" data-testid="flyers-section">
          <h3 className="mb-6 font-display text-3xl text-gold">
            Upcoming <span className="font-script normal-case tracking-normal text-red-500">Events</span>
          </h3>
          {flyers.length === 0 && <p className="text-neutral-500">Flyers coming soon.</p>}
          <div className="no-scrollbar -mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4">
            {flyers.map((f, i) => (
              <button
                key={f.id}
                data-testid={`flyer-image-${i}`}
                onClick={() => setActive(f)}
                className="w-[72%] shrink-0 snap-start overflow-hidden rounded-md border-2 border-amber-500/30 transition-colors hover:border-amber-500 sm:w-[300px]"
              >
                <img src={imgUrl(f.url)} alt={f.caption || "Festival flyer"} loading="lazy" className="aspect-[3/4] w-full object-cover" />
              </button>
            ))}
          </div>
        </div>
      </div>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-3xl border-neutral-800 bg-neutral-950 p-2" data-testid="lightbox">
          <DialogTitle className="sr-only">{active?.caption || "Image"}</DialogTitle>
          {active && <img src={imgUrl(active.url)} alt={active.caption} className="max-h-[80vh] w-full rounded object-contain" />}
          {active?.caption && <p className="px-2 pb-2 font-display text-neutral-300">{active.caption}</p>}
        </DialogContent>
      </Dialog>
    </section>
  );
};
